import type {KeyTextField, RichTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import cn from 'classnames'
import {CheckIconVariation} from './CheckIconVariation'

type Props = {
  title: KeyTextField
  subtitle: KeyTextField
  benefits: {
    benefit: RichTextField
  }[]
  isGreenBackground: boolean
}

export const BenefitsCard = ({title, subtitle, benefits, isGreenBackground}: Props) => (
  <div
    className={cn('flex flex-1 flex-col gap-4 rounded-lg border   p-6 md:gap-6 md:px-8 md:pb-8', {
      'bg-[#FFFFFF05] border-moss-white/10': isGreenBackground,
      'bg-moss-white border-black/10': !isGreenBackground,
    })}
  >
    <div className="flex flex-col tracking-tight">
      {isFilled.keyText(title) && (
        <p
          className={cn('text-24 font-medium leading-normal ', {
            'text-moss-white': isGreenBackground,
            'text-[#2A2928]': !isGreenBackground,
          })}
        >
          {title}
        </p>
      )}

      {isFilled.keyText(subtitle) && (
        <p
          className={cn('text-24 font-medium leading-normal ', {
            'text-[#FFFFFFB3]': isGreenBackground,
            'text-[#2A2928B2]': !isGreenBackground,
          })}
        >
          {subtitle}
        </p>
      )}
    </div>
    <div className="flex flex-col gap-3">
      {benefits.map((item, index) => (
        <div key={index} className="flex items-start gap-2">
          <div className="flex shrink-0 items-start pt-[3px] md:pt-0.5">
            <CheckIconVariation variant="neon" />
          </div>
          <div
            className={cn('text-15 leading-[22px] md:leading-5 [&_strong]:font-semibold', {
              'text-moss-white': isGreenBackground,
              'text-moss-grey-500': !isGreenBackground,
            })}
          >
            <PrismicRichText field={item.benefit} />
          </div>
        </div>
      ))}
    </div>
  </div>
)
